import { Box } from '@mui/material'

import { VariationBadge } from '#/store/providers/Pagebuilder/Components/Card'

export interface Value {
  status: number
  text: string
}

interface TypeNeedPushUpProps {
  value?: Value | null
}

export const TypeNeedPushUp: React.FC<TypeNeedPushUpProps> = ({ value }) => {
  if (!value?.status) return null

  return (
    <Box sx={{ alignItems: 'center', display: 'flex' }}>
      <VariationBadge label={value.text} variationlevel="warning" />
    </Box>
  )
}
